import {useRef, useState} from "react"
import Text from "../../components/input/text";
import Email from "../../components/input/email";
import Button from "../../components/button";
import Alert from "../../components/alert";
import UseGetFormData from "../../hooks/UseGetFormData";
import {enterprise_info} from "../../config/tips";
import CardMenu from "../../components/card-menu";
import Menu from "./Menu"
import {UsePost} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import {Card, Col, Row} from "react-bootstrap";
import {useEnterprise} from "./EnterpriseProvider";
import {useNavigate} from "react-router-dom";

const EnterpriseForm = () => {
    const formRef = useRef()
    const navigate = useNavigate()

    const {enterprise, domain, loading} = useEnterprise();
    const idEnterprise = enterprise?._id?.$oid;

    const EnterpriseMenu = Menu({id: idEnterprise})

    const [errors, setErrors] = useState()
    const [isLoading, setIsLoading] = useState(false)


    const handleUpsert = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)


        setIsLoading(true)
        UsePost(
            `/enterprises/upsert/${idEnterprise || ''}`,
            {
                data: {
                    vat  : FormData.get('vat'),
                    name : FormData.get('name'),
                    email: FormData.get('email'),
                    phone: FormData.get('phone'),
                }
            }
        ).then((response) => {
            window.setTimeout(() => {

                if (response.code >= 200 && response.code <= 299) {
                    navigate(`/enterprises/${response._id}`)
                    const action = idEnterprise ? 'updated' : 'created'
                    UseMessage('success', `Enteprise has been successfully ${action}.`)
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }


    return (
        <Card>
            <Row>
                <Col>
                    <div className="max-width-600">
                        <form autoComplete="off" ref={formRef} onSubmit={handleUpsert}>
                            <CardMenu {...EnterpriseMenu} />

                            <Alert
                                icon="info"
                                docsPath="/docs/enterprises"
                                message={enterprise_info}
                            />

                            <Text required
                                size="md"
                                name="name"
                                label="Name"
                                isReady={!isLoading}
                                error={errors?.name}
                                value={enterprise?.name}
                                placeholder="Type a name for your enterprise"
                            />

                            <Email required
                                size="md"
                                name="email"
                                label="Email"
                                isReady={!isLoading}
                                error={errors?.email}
                                value={enterprise?.email}
                                placeholder="Enterprise owner email"
                            />

                            <Text required
                                size="md"
                                name="phone"
                                label="Phone"
                                isReady={!isLoading}
                                error={errors?.phone}
                                value={enterprise?.phone}
                                placeholder="Enterprise owner email"
                            />


                            <Text
                                size="md"
                                name="vat"
                                label="Vat Number"
                                isReady={!isLoading}
                                error={errors?.vat}
                                value={enterprise?.vat}
                                placeholder="Enterprise owner vat number"
                            />

                            <Button
                                size="sm"
                                className="mt-2"
                                color="primary"
                                isReady={!isLoading}
                                icon={enterprise ? 'check' : 'plus'}
                                label={enterprise ? 'Update' : 'Create'}
                            />
                        </form>
                    </div>
                </Col>
            </Row>
        </Card>
    )
}

export default EnterpriseForm